import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import TopBar from "../../components/TopBarV2";
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import Link from "@mui/material/Link/Link";


import firebase from "../../firebase/firebase";
import {useContext} from "react";
import {AuthUserContext} from "../../providers/AuthProvider";
import Spinner from "../../components/spinner";
import {useNavigate, useParams} from "react-router-dom";
import moment from 'moment'
import Button from "@mui/material/Button/Button";
import ScrollToTop from "../../utils/scrollTop";
const storageRef = firebase.storage().ref();
function LayerTwoProjectDetails() {
  const { user} = useContext(AuthUserContext);
  const [projectImage, setProjectImage] = React.useState();
  const [project, setProject] = React.useState();

  const [loading, setLoading] = React.useState(true);
  const navigator = useNavigate()

  let { projectId } = useParams();

  const formik = {
    values: {}
  }
  const downloadURL = (url) => new Promise(((resolve, reject) => {
    const mediaRef = storageRef.child(url);

// Get the download URL
    mediaRef.getDownloadURL()
      .then((url) => {
        resolve(url);
        // setImageUrl(url)
        // setLoading(false)
        // Insert url into an <img> tag to "download"
      })
      .catch((error) => {
        reject(error)
        // setLoading(false)

        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/object-not-found':
            // File doesn't exist
            break;
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;

          // ...

          case 'storage/unknown':
            // Unknown error occurred, inspect the server response
            break;
        }
      });
  }))

  React.useEffect(() => {
    if (projectId) {
      const projectRef = firebase.firestore().collection('projects').doc(projectId);
      projectRef.get()
        .then(async (snapshot) => {
          setLoading(false)

          const projectUser = await firebase.firestore().collection('users').where('uid', '==', snapshot.data().uid).get();
          if (projectUser?.docs && projectUser?.docs.length > 0 ) {
            setProject({...snapshot.data(), name:projectUser?.docs[0].data().name})
          }

          if (snapshot.data().mediaFiles) {
            if (snapshot.data().mediaFiles.image) {
              const image = await downloadURL(snapshot.data().mediaFiles.image)
              setProjectImage({src: image, })
            }
          }
        })
        .catch((err) => setLoading(false))
    }
    else setLoading(false)
  }, []);
  if (loading) return <Spinner/>
  return(
    <React.Fragment>
      <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {/* Hero unit */}
      {/*<TopBar showBar={true}/>*/}
      <Container maxWidth="lg" sx={{textAlign: 'left', p:5}}>
        <Stack direction="row" spacing={5} sx={{width: '90%', mb: 1.5}}>
        {/*  <Typography variant={'h6'} color={'primary'} sx={{flex:1}}>
            <b>{projectId && project && project?.title !== '' ?  project?.title : 'Add project'}</b>
          </Typography>*/}
        </Stack>
        <Stack direction="row" spacing={5}>
          <Stack direction={'column'}  alignItems="start" spacing={2} sx={{width:'250px'}}>
            {projectImage && projectImage?.src && <img src={projectImage.src} style={{width:255,  height: 310, borderRadius: '14px',position: 'relative',
              top: 0,
              right: 0, opacity:  1, objectFit:'cover'}} alt=""/>}
            <Typography variant={'h6'} color={'primary'} sx={{flex:1, textAlign: 'center'}}>
              <b>{project?.name}</b>
            </Typography>
          </Stack>
          <Stack direction={'column'}  sx={{flex:1, pr: 15,}} spacing={5}>

            {project &&  <Stack direction={'column'}
                                justifyContent="start"
                                alignItems="start"
                                spacing={3}
                                sx={{width:'100%'}} >

              <>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Project title
                  </Typography>

                  <Typography variant={'body1'} >
                    {project?.title}
                  </Typography>

                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Bio / Description
                  </Typography>

                  <Typography variant={'body1'} >
                    {project?.description}
                  </Typography>

                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Project type
                  </Typography>

                  <Typography variant={'body1'} >
                    {project?.type}
                  </Typography>

                </Stack>
                <Stack direction={'row'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={3}
                       sx={{width:'100%'}}>
                  <Stack direction={'column'}
                         justifyContent="start"
                         alignItems="start"
                         spacing={.5} sx={{width: '100%'}}>

                    <Typography variant={'body2'} color={'secondary'}>
                      Production start date
                    </Typography>

                    <Typography variant={'body1'} >
                      {moment(project?.startDate).format('Do MMMM YYYY')}
                    </Typography>

                  </Stack>
                  <Stack direction={'column'}
                         justifyContent="start"
                         alignItems="start"
                         spacing={.5} sx={{width: '100%'}}>

                    <Typography variant={'body2'} color={'secondary'}>
                      Production end date
                    </Typography>

                    <Typography variant={'body1'} >
                      {moment(project?.endDate).format('Do MMMM YYYY')}
                    </Typography>

                  </Stack>
                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Genre
                  </Typography>

                  <Typography variant={'body1'} >
                    {project?.genre}
                  </Typography>

                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Language
                  </Typography>

                  <Typography variant={'body1'} >
                    {project?.language}
                  </Typography>

                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Production locations
                  </Typography>

                  <Typography variant={'body1'} >
                    {project?.location}
                  </Typography>

                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Synopsis
                  </Typography>

                  <Typography variant={'body1'} >
                    {project?.synopsis}
                  </Typography>

                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Website
                  </Typography>
                  <Link  href={project?.website} target="_blank" variant={'body1'} >
                    {project?.website}
                  </Link>

                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    IMDB
                  </Typography>
                  <Link  href={project?.imdb} target="_blank" variant={'body1'} >
                    {project?.imdb}
                  </Link>

                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Vimeo
                  </Typography>
                  <Link  href={project?.vimeo} target="_blank" variant={'body1'} >
                    {project?.vimeo}
                  </Link>

                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Facebook
                  </Typography>
                  <Link  href={project?.facebook} target="_blank" variant={'body1'} >
                    {project?.facebook}
                  </Link>

                </Stack>
                <Stack direction={'column'}
                       justifyContent="start"
                       alignItems="start"
                       spacing={.5} sx={{width: '100%'}}>

                  <Typography variant={'body2'} color={'secondary'}>
                    Instagram
                  </Typography>
                  <Link  href={project?.instagram} target="_blank" variant={'body1'} >
                    {project?.instagram}
                  </Link>

                </Stack>
                <Stack direction={'row'}
                       justifyContent="center"
                       alignItems="center" sx={{width:'100%', height: 100}}>
                  <Button variant={'contained'} sx={{paddingX: 5}} onClick={() => {
                    console.log('Continue')
                    navigator(`/investor/nda-information/${projectId}`)
                  }}>Continue</Button></Stack>


              </>





            </Stack>}



          </Stack>
        </Stack>
      </Container>

    </React.Fragment>
  )
}
export default LayerTwoProjectDetails;